import { makeAuthorizedGetRequestToBackend, makeUrl } from "./backendApi";
import { useAsync } from "react-use";
import { useMe } from "../hooks/useMe";
import { useAppMode, useItinMode } from "../store/model-misc";

export function useEndpoint(endpoint) {
  const me = useMe();
  const appMode = useAppMode();
  const itinMode = useItinMode();
  const notReady = me.loading || !appMode || !itinMode;
  const fn = async () => {
    if (notReady) return {};
    const { data } = await makeAuthorizedGetRequestToBackend({
      url: makeUrl({ endpoint, appMode, itinMode }),
    });
    return data;
  };
  const { loading, value: data } = useAsync(fn, [
    endpoint,
    me.loading,
    appMode,
    itinMode,
  ]);
  if (notReady) return { loading: true, value: undefined };
  return { loading, data };
}
